module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-466.f32d4d0.woff2";